import Lottie, { LottieRefCurrentProps } from 'lottie-react';
import playpause from '@assets/lottie/playpause.json';
import { useEffect, useRef, useState } from 'react';

interface Props {
  state: 'playing' | 'paused';
  onClick: () => void;
  height?: number;
  width?: number;
}

const PlayPause = ({ state, onClick, height = 30, width = 30 }: Props) => {
  const [ready, setReady] = useState(false);
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    if (!ready) return;
    if (lottieRef.current === null) return;
    if (state === 'playing') {
      lottieRef.current.playSegments([94, 150], true);
    }
    if (state === 'paused') {
      lottieRef.current.playSegments([0, 30], true);
    }
  }, [state]);

  return (
    <Lottie
      initialSegment={[30, 30]}
      lottieRef={lottieRef}
      animationData={playpause}
      autoplay={false}
      loop={false}
      style={{
        height,
        width
      }}
      onClick={onClick}
      onDOMLoaded={() => setReady(true)}
    />
  );
};

export default PlayPause;
